import { render, staticRenderFns } from "./TableDetailModal.vue?vue&type=template&id=ed5bdc02&scoped=true"
import script from "./TableDetailModal.vue?vue&type=script&lang=js"
export * from "./TableDetailModal.vue?vue&type=script&lang=js"
import style0 from "./TableDetailModal.vue?vue&type=style&index=0&id=ed5bdc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bdc02",
  null
  
)

export default component.exports